import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { LocalStorageProperties } from '../../globaldependencies/constants/localstorage-properties';
import { SignalRCoreHubConnectionState } from '../models/hub-connection-state-enum';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class RealTimeSignalRCoreHub implements OnDestroy {

  public testAutomationChanged = new EventEmitter<any>();
  hubConnection: any = null;
  loggedInUserId: string;
  companyId: string;
  connectionInProgress: boolean = false;
  canViewLiveStatus: boolean = false;
  retryConnecting: number = 0;

  environment = JSON.parse(localStorage.getItem(LocalStorageProperties.Environment));
  apiURL = localStorage.getItem(LocalStorageProperties.HydaSignalRBasePath) || this.environment.apiURL;

  constructor() { }

  async establishConnectionWithHYDAHub() {
    console.log("[HYDA SignalR] Connection method called");
    while (true) {
      if (localStorage.getItem(LocalStorageProperties.IsSignalREnabled) != null && localStorage.getItem(LocalStorageProperties.IsSignalREnabled) != undefined) {
        this.canViewLiveStatus = localStorage.getItem(LocalStorageProperties.IsSignalREnabled) == 'true' ? true : false;
      }
      else {
        this.canViewLiveStatus = false;
      }
      if (localStorage.getItem(LocalStorageProperties.HydaSignalRBasePath)!=null && localStorage.getItem(LocalStorageProperties.HydaSignalRBasePath)!=undefined) {
        this.apiURL = localStorage.getItem(LocalStorageProperties.HydaSignalRBasePath);
        console.log("[SIGNALR] Setting API URL: " + this.apiURL);
      }

      console.log("Hyda SignalRBasePath", localStorage.getItem(LocalStorageProperties.HydaSignalRBasePath));

      if (this.canViewLiveStatus) {
        this.checkConnectionWithHYDAHub(false);
      } else {
        this.disconnect();
      }
      await this.delay(6000);
    }
  }

  checkConnectionWithHYDAHub(isForceIntialize) {
    if (isForceIntialize || this.retryConnecting > 3 || (this.connectionInProgress == false &&
      (this.hubConnection == null || this.hubConnection == undefined ||
        this.hubConnection.state == SignalRCoreHubConnectionState.Disconnected
      ))) {
      this.retryConnecting = 0;
      this.establishSignalrConnection();
    } else if (this.hubConnection.state == SignalRCoreHubConnectionState.Reconnecting || this.hubConnection.state == SignalRCoreHubConnectionState.Connecting) {
      console.log("connection is in connecting state on retry " + this.retryConnecting)
      this.retryConnecting = this.retryConnecting + 1;
    } else {
      this.retryConnecting = 0;
      console.log("stable connection already exist");
    }
  }

  private async establishSignalrConnection() {
    if (this.hubConnection) {
      if (!this.isSignalRConnected()) {
        await this.hubConnection.start().then(() => {
          console.log("Connection Established successfully");
          if (this.checkIfValidGUID(this.loggedInUserId)) {
            this.invokeTestAutomationSubscription(this.loggedInUserId);
          }
          this.connectionInProgress = false;
        }).catch(() => {
          console.log("Connection Disconnected");
          this.hubConnection = null;
        });
      }
    }

    if (this.connectionInProgress) {
      console.log('[SIGNALR CORE] Connection already in progress, skipping.');
      return;
    }

    this.connectionInProgress = true;

    if (this.hubConnection && this.hubConnection.state === SignalRCoreHubConnectionState.Connected) {
      console.log('[SIGNALR CORE] Already connected, skipping connection.');
      this.connectionInProgress = false;
      return;
    }

    console.log('[SIGNALR CORE] Creating and starting new hub connection...');

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.apiURL}HYDA`)
      .configureLogging(signalR.LogLevel.Trace)
      .build();

    this.hubConnection.on('TestAutomation', (data: any) => {
      this.testAutomationChanged.next(data);
      console.log(data, "testautomationdatastatus");
    });

    this.hubConnection.on('someThingWentWrong', (exceptionMessage: string) => {
      console.error('[SIGNALR CORE]', exceptionMessage);
    });

    try {
      await this.hubConnection.start().then(() => console.log('Connected via LongPolling'))
        .catch(err => console.error('Connection failed: ', err));;
      console.log('[HYDA SignalR] Connection established successfully');

      if (this.checkIfValidGUID(this.loggedInUserId)) {
        this.invokeTestAutomationSubscription(this.loggedInUserId);
      }
      this.connectionInProgress = false;
    } catch (err) {
      console.error('[HYDA SignalR] Connection failed', err);
      this.connectionInProgress = false;
    }

    this.hubConnection.onclose(error => {
      console.log('Connection closed:', error);
    });
  }


  public initialize() {
    console.log("[HYDA SIGNALR] Initalise Called");
    this.loggedInUserId = JSON.parse(localStorage.getItem(LocalStorageProperties.UserModel)).id;
    this.companyId = JSON.parse(localStorage.getItem(LocalStorageProperties.UserModel)).companyId;
    this.environment = JSON.parse(localStorage.getItem(LocalStorageProperties.Environment));
    this.connectionInProgress = false;
    this.canViewLiveStatus = false;
    this.retryConnecting = 0;
    var apiURL = localStorage.getItem(LocalStorageProperties.HydaSignalRBasePath) || this.environment.apiURL;
    if (apiURL != this.apiURL) {
      this.restartSignalRConnection();
    }
    else {
      this.establishConnectionWithHYDAHub();
    }
    console.log("[SIGNALR] Initalise Finished");
  }

  public restartSignalRConnection() {
    this.hubConnection = null;
    this.apiURL = localStorage.getItem(LocalStorageProperties.HydaSignalRBasePath) || this.environment.apiURL;
    this.establishConnectionWithHYDAHub();
  }

  private checkIfValidGUID(str) {
    const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

    return regexExp.test(str);
  }

  public async invokeTestAutomationSubscription(userId: string) {
    if (this.isSignalRConnected()) {
      try {
        await this.hubConnection.invoke("SubscribeToTestAutomation", userId);
        console.log(`[HYDA SignalR] Sent SubscribeToTestAutomation request: ${userId}`);
      } catch (e) {
        console.error("[HYDA SignalR] SubscribeToTestAutomation failed", e);
      }
    } else {
      console.log("[HYDA SignalR] invokeTestAutomationSubscription skipped as SignalR not connected");
    }
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private isSignalRConnected(): boolean {
    return this.hubConnection != null && this.hubConnection.state == signalR.HubConnectionState.Connected;
  }

  private async disconnect() {
    if (this.hubConnection && this.hubConnection.state !== signalR.HubConnectionState.Disconnected) {
      try {
        await this.hubConnection.stop();
        console.log('[HYDA SignalR] Disconnected successfully');
      } catch (e) {
        console.error(e);
      }
    }
  }

  ngOnDestroy(): void {
    this.testAutomationChanged.complete();
    this.disconnect();
  }
}
